import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import CategoryOnlineReportContent from './CategoryOnlineReportContent';
import { setFromDate, setToDate, setSelectedBranch, fetchCategoryOnlineFullReport } from './categoryOnlineReportSlice';

const CategoryOnlineReportAdmin = () => {
    const dispatch = useDispatch();
    const storedBranchId = localStorage.getItem('branchid') || '';

    useEffect(() => {
        const toDate = new Date();
        const fromDate = new Date();
        fromDate.setDate(fromDate.getDate() - 30);
        dispatch(setFromDate(fromDate));
        dispatch(setToDate(toDate));
        dispatch(setSelectedBranch({ branch_id: storedBranchId || 'All', branch_name: 'Branch' }));
        dispatch(
            fetchCategoryOnlineFullReport({
                fromDate,
                toDate,
                branchId: storedBranchId || 'All'
            })
        );
    }, [dispatch, storedBranchId]);

    return <CategoryOnlineReportContent />;
};

export default CategoryOnlineReportAdmin;
